export default __webpack_public_path__ + "static/media/GEN_About_Content_02.30ff97b0.jpg";